import { format, parseISO, differenceInDays, isBefore, isEqual, startOfDay } from "date-fns";

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return format(parseISO(iso), "dd MMM yyyy");
  } catch {
    return iso;
  }
}

export function fmtAmount(value, currency = "INR") {
  const n = Number(value || 0);
  const map = { INR: "₹", USD: "$", EUR: "€", GBP: "£" };
  const symbol = map[currency] || `${currency} `;
  return `${symbol}${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtCompact(value, currency = "INR") {
  const n = Number(value || 0);
  const map = { INR: "₹", USD: "$", EUR: "€", GBP: "£" };
  const symbol = map[currency] || `${currency} `;
  const formatter = new Intl.NumberFormat("en-IN", { notation: "compact", maximumFractionDigits: 1 });
  return `${symbol}${formatter.format(n)}`;
}

export function statusOf(nextDueISO) {
  if (!nextDueISO) return "scheduled";
  const today = startOfDay(new Date());
  const due = startOfDay(parseISO(nextDueISO));
  if (isBefore(due, today)) return "overdue";
  if (isEqual(due, today)) return "due-today";
  const diff = differenceInDays(due, today);
  if (diff <= 7) return "upcoming";
  return "scheduled";
}

export const STATUS_STYLES = {
  overdue: "bg-rose-50 text-rose-700 border border-rose-200",
  "due-today": "bg-amber-50 text-amber-800 border border-amber-200",
  upcoming: "bg-amber-50 text-amber-700 border border-amber-200",
  scheduled: "bg-slate-50 text-slate-700 border border-slate-200",
  paid: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  completed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
};

export const FREQUENCIES = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "bi-monthly", label: "Bi-monthly (every 2 months)" },
  { value: "quarterly", label: "Quarterly" },
  { value: "half-yearly", label: "Half-yearly" },
  { value: "yearly", label: "Yearly" },
  { value: "custom", label: "Custom (N days)" },
  { value: "one-time", label: "One-Time (no recurrence)" },
];

// Legacy type-value → readable label (only used as fallback for old rows before backend migration)
const LEGACY_TYPE_LABELS = {
  recurring_expense: "Recurring",
  emi: "EMI",
  loan_repayment: "Loan Repayment",
  liability: "Liability",
};

export function typeLabel(v) {
  if (!v) return "—";
  return LEGACY_TYPE_LABELS[v] || v;
}

export const PAYMENT_MODES = [
  { value: "auto", label: "Auto Debit" },
  { value: "manual", label: "Manual" },
];
